var exports = {
  "PM": "FeedReportModal.module__step___NmI3TD",
  "Fb": "FeedReportModal.module__stepTitle___NmI3TD",
  "Du": "FeedReportModal.module__stepBody___NmI3TD",
  "WG": "FeedReportModal.module__inlineNote___NmI3TD",
};

module.exports = exports;
